// Lets a customer switch the color of a "Wheel Lug Nut / Bolt Kit" line already in their cart
// (see snippets/cart-item.liquid). Since a cart line's variant can't be changed in place, this
// removes the old line and adds the new variant at the same quantity, then reloads — simplest
// reliable way to land in a consistent state without hand-rolling the same section refresh
// logic cart-provider.js already does for the normal add/change flows.
(() => {
    const VEHICLE_STORAGE_KEY = 'unleashed:selected-vehicle';

    function readVehicleLabel() {
        try {
            const raw = localStorage.getItem(VEHICLE_STORAGE_KEY);
            if (!raw) return null;
            const v = JSON.parse(raw);
            if (!v?.year || !v?.make || !v?.model) return null;
            return `${v.year} ${v.make} ${v.model}`;
        } catch (e) {
            return null;
        }
    }

    document.addEventListener('change', async (e) => {
        if (!e.target.matches('[data-lug-kit-color-switch]')) return;
        const select = e.target;
        const oldKey = select.getAttribute('data-item-key');
        const newVariantId = select.value;
        const qtyInput = document.getElementById(`Quantity-${oldKey}`);
        const quantity = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
        const vehicleLabel = readVehicleLabel();
        const newItem = { id: +newVariantId, quantity };
        if (vehicleLabel) newItem.properties = { Vehicle: vehicleLabel };

        select.disabled = true;
        try {
            await fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ id: oldKey, quantity: 0 }),
            });
            await fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ items: [newItem] }),
            });
        } finally {
            window.location.reload();
        }
    });
})();
